export const BASE_URL = 'https://radiogarden.com.tr/admin/public/api';
